<!--门静脉CTV-->
<script setup>
import { ref,computed, reactive } from "vue";
import { useCrfStore } from "@/stores/crf";
import upload from "@/components/upload1.vue"
import uploadzip from "@/components/upload.vue"
import check from "./check.vue";
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0


// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});

let show = ref(false)
// 表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
</script>
<template>
  <template v-if="crfFields">
    <div style="display:flex;">
      <h2>门静脉CTV</h2>
      <upload :type="props.type" :data="model" name="mjmctv"></upload>
      <check :period="props.type" text="门静脉CTV" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
    </div>
    <el-form-item label="门静脉CTV检查是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['门静脉CTV检查是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['门静脉CTV检查是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'患者是否新增门静脉CTV检查？':'患者是否进行门静脉CTV检查？'" class="redStar">
          <el-radio-group v-model="crfFields['患者是否进行门静脉CTV检查？']">
            <el-radio label="是"></el-radio>
            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="crfFields['患者是否进行门静脉CTV检查？'] == '是'">

          <el-form-item label="侧支循环开放" :prop="itemProp(`门静脉CTV：侧支循环开放`)" :rules="crfStore.radioRules(`侧支循环开放`,true)"  class="redStar" >
            <el-radio-group v-model="crfFields['门静脉CTV：侧支循环开放']">
              <el-radio label="有" prop="有"></el-radio>
              <el-radio label="无" prop="无"></el-radio>
              <el-radio label="未测" prop="未测"></el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item  v-if="crfFields['门静脉CTV：侧支循环开放'] == '有'"  class="not_redStar">
            <el-checkbox-group v-model="crfFields['门静脉CTV：多选']">
              <el-checkbox label="食管胃底静脉曲张" prop="食管胃底静脉曲张"></el-checkbox>
              <el-checkbox label="脐静脉开放" prop="脐静脉开放"></el-checkbox>
              <el-checkbox label="脾肾分流" prop="脾肾分流"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="门静脉血栓"  :prop="itemProp(`门静脉CTV：门静脉血栓`)" :rules="crfStore.radioRules(`门静脉血栓`,true)"  class="redStar">
            <el-radio-group v-model="crfFields['门静脉CTV：门静脉血栓']">
              <el-radio label="有" prop="有"></el-radio>
              <el-radio label="无" prop="无"></el-radio>
              <el-radio label="未测" prop="未测"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="门静脉海绵样变"  :prop="itemProp(`门静脉CTV：门静脉海绵样变`)" :rules="crfStore.radioRules(`门静脉海绵样变`,true)"  class="redStar">
            <el-radio-group v-model="crfFields['门静脉CTV：门静脉海绵样变']">
              <el-radio label="有" prop="有"></el-radio>
              <el-radio label="无" prop="无"></el-radio>
              <el-radio label="未测" prop="未测"></el-radio>
            </el-radio-group>
          </el-form-item>
          <uploadzip :type="props.type" :data="model" name="mjmctvzip"></uploadzip>

        </template>
      </template>
    <!-- <button class="button"  @click.prevent="show = !show">{{show? '隐藏选项':'展开选项'}}</button> -->
    <!-- <el-form-item label="门静脉CTV" class="redStar">
        <el-input v-model="crfFields['门静脉CTV']" autocomplete="off"
        placeholder="具体数值或管径描述"></el-input> 
    </el-form-item> -->
  </template>
</template>

<style scoped>
</style>